import { type KeyboardEvent } from "react"

interface ChatInputProps {
  input: string
  onInputChange: (value: string) => void
  onSubmit: (text: string) => void
  isLoading: boolean
}

export function ChatInput({
  input,
  onInputChange,
  onSubmit,
  isLoading,
}: ChatInputProps) {
  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      if (input.trim() && !isLoading) {
        onSubmit(input)
      }
    }
  }

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (input.trim() && !isLoading) {
      onSubmit(input)
    }
  }

  return (
    <form
      onSubmit={handleFormSubmit}
      className="border-t border-system-blue-600 p-3"
    >
      <div className="flex items-end gap-2">
        <textarea
          className="textarea textarea-bordered flex-1 resize-none text-base min-h-[40px] max-h-[120px] bg-system-blue-600 border-system-blue-500 placeholder:text-gray/60"
          rows={1}
          placeholder="Ask about your data..."
          value={input}
          onChange={e => onInputChange(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
        />
        <button
          type="submit"
          className="btn btn-primary btn-md"
          disabled={!input.trim() || isLoading}
        >
          {isLoading ? (
            <span className="loading loading-spinner loading-xs" />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="w-5 h-5"
            >
              <path d="M3.105 2.288a.75.75 0 0 0-.826.95l1.414 4.926A1.5 1.5 0 0 0 5.135 9.25h6.115a.75.75 0 0 1 0 1.5H5.135a1.5 1.5 0 0 0-1.442 1.086l-1.414 4.926a.75.75 0 0 0 .826.95 28.11 28.11 0 0 0 15.095-7.175.75.75 0 0 0 0-1.074A28.11 28.11 0 0 0 3.105 2.288Z" />
            </svg>
          )}
        </button>
      </div>
    </form>
  )
}
